export function initJenisPekerjaan() {
    // Icon Preview Logic
    const iconInput = document.getElementById('icon');
    const iconPreview = document.getElementById('iconPreview');
    if (iconInput && iconPreview) {
        iconInput.addEventListener('input', function() {
            const iconClass = this.value.startsWith('bi-') ? this.value : 'bi-' + this.value;
            iconPreview.className = 'bi ' + iconClass;
        });
    }

    // Material Management Logic
    let materialRowIndex = 0;
    const materialList = $('#materialLinkList');
    const template = $('#materialRowTemplate').html();

    function addMaterialRow(data = null) {
        const index = materialRowIndex++;
        
        // Ensure template exists before replacement. It will be moved to index.php if not inline anymore
        if (!template) return;
        
        let rowHtml = template.replace(/INDEX/g, index);
        const row = $(rowHtml);
        
        materialList.append(row);

        // Initialize Select2 with AJAX for the new row
        const select = row.find('.select2-material');
        select.select2({
            dropdownParent: $('#modalManageMaterials'),
            theme: 'bootstrap-5',
            width: '100%',
            placeholder: '-- Cari Material --',
            ajax: {
                url: '/material/ajax-search',
                dataType: 'json',
                delay: 500,
                data: function (params) {
                    return {
                        q: params.term, // search term
                    };
                },
                processResults: function (response) {
                    if (response.status === 'success') {
                        return {
                            results: response.data.map(function(item) {
                                return {
                                    id: item.id_material,
                                    text: item.nama_material + ' (' + item.satuan + ')',
                                    satuan: item.satuan
                                }
                            })
                        };
                    }
                    return { results: [] };
                },
                cache: true
            },
            minimumInputLength: 0
        });

        // Handle satuan label update
        select.on('select2:select', function(e) {
            const satuan = e.params.data.satuan || '-';
            row.find('.satuan-label').text(satuan);
        });

        // Handle form reset clearing
        select.on('change', function() {
            if(!$(this).val()) {
                row.find('.satuan-label').text('-');
            }
        });

        // If it's existing data, fill it by appending a new option
        if (data) {
            const option = new Option(data.nama_material + ' (' + data.satuan + ')', data.id_material, true, true);
            select.append(option).trigger('change');
            
            // Set additional custom data manually if needed for Select2
            select.trigger({
                type: 'select2:select',
                params: {
                    data: {
                        id: data.id_material,
                        text: data.nama_material + ' (' + data.satuan + ')',
                        satuan: data.satuan
                    }
                }
            });

            row.find('input[type="number"]').val(data.jumlah_standar);
        }
    }

    $('#btnAddMaterialRow').on('click', function() {
        addMaterialRow();
    });

    materialList.on('click', '.btn-remove-row', function() {
        $(this).closest('.material-row').fadeOut(300, function() {
            $(this).remove();
        });
    });

    $('.btn-manage-materials').on('click', function() {
        const id = $(this).data('id');
        const name = $(this).data('name');
        
        $('#materialJenisName').text(name);
        $('#formManageMaterials').attr('action', '/jenis-pekerjaan/' + id + '/materials');
        
        // Reset list and index
        materialList.empty();
        materialRowIndex = 0;
        
        // Load existing materials
        $.get('/jenis-pekerjaan/' + id + '/materials', function(res) {
            if (res.status === 'success' && res.data.length > 0) {
                res.data.forEach(m => addMaterialRow(m));
            } else {
                addMaterialRow(); // Add one empty row
            }
            $('#modalManageMaterials').modal('show');
        }).fail(function() {
            Swal.fire('Error', 'Gagal memuat data material', 'error');
        });
    });

    $('#formManageMaterials').on('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const btn = $('#btnSaveMaterials');
        btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1"></span> Menyimpan...');
        
        $.ajax({
            url: $(this).attr('action'),
            method: 'POST',
            data: $(this).serialize(),
            success: function(res) {
                if (res.status === 'success') {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil',
                        text: res.message,
                        timer: 1500,
                        showConfirmButton: false
                    }).then(() => {
                        $('#modalManageMaterials').modal('hide');
                    });
                }
            },
            error: function(err) {
                Swal.fire('Error', err.responseJSON?.message || 'Gagal menyimpan perubahan', 'error');
            },
            complete: function() {
                btn.prop('disabled', false).html('<i class="bi bi-check-lg me-1"></i> Simpan Perubahan');
            }
        });
    });
}
